export const MB = 1024 * 1024;
export const DEFAULT_MAX_IMAGE_UPLOAD_SIZE_MB = 20;
export const DEFAULT_MAX_IMAGE_UPLOAD_SIZE_BYTES = DEFAULT_MAX_IMAGE_UPLOAD_SIZE_MB * MB;
export const IMAGE_COMPRESSION_SCALE_STEP = 0.8;
